const leadTriggers = document.querySelectorAll("[data-lead-trigger]");
const leadForm = document.querySelector("#lead-form");
const leadInterest = document.querySelector("[data-lead-interest]");
const leadBody = document.querySelector("[data-lead-body]");
const header = document.querySelector("[data-elevates]");
const mobileMenuToggle = document.querySelector("[data-mobile-menu-toggle]");
const dataCalculator = document.querySelector("[data-data-calculator]");
const calculatorEstimateEndpoint = "https://esimagent-82221.web.app/api/send-calculator-estimate-email";
const calculatorUnknownDestination = "Not sure yet";
const calculatorSupportedDestinations = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong (China)",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao (China)",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Malta",
  "Martinique",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of the Congo",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turks and Caicos Islands",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vatican City",
  "Vietnam",
  "Virgin Islands- British",
  "Zambia",
];
const attributionFields = {
  pageUrl: document.querySelector("[data-lead-page-url]"),
  landingUrl: document.querySelector("[data-lead-landing-url]"),
  referrer: document.querySelector("[data-lead-referrer]"),
  ctaLocation: document.querySelector("[data-lead-cta-location]"),
  utmSource: document.querySelector("[data-lead-utm-source]"),
  utmMedium: document.querySelector("[data-lead-utm-medium]"),
  utmCampaign: document.querySelector("[data-lead-utm-campaign]"),
  utmContent: document.querySelector("[data-lead-utm-content]"),
  utmTerm: document.querySelector("[data-lead-utm-term]")
};

function setField(field, value) {
  if (field) field.value = value || "";
}

function landingUrl() {
  const key = "esimAgentLandingUrl";
  const current = window.location.href;

  try {
    const existing = window.sessionStorage?.getItem(key);
    if (existing) return existing;
    window.sessionStorage?.setItem(key, current);
  } catch {
    return current;
  }

  return current;
}

function setLeadAttribution(location = "") {
  const params = new URLSearchParams(window.location.search);

  setField(attributionFields.pageUrl, window.location.href);
  setField(attributionFields.landingUrl, landingUrl());
  setField(attributionFields.referrer, document.referrer || "Direct / unknown");
  setField(attributionFields.utmSource, params.get("utm_source"));
  setField(attributionFields.utmMedium, params.get("utm_medium"));
  setField(attributionFields.utmCampaign, params.get("utm_campaign"));
  setField(attributionFields.utmContent, params.get("utm_content"));
  setField(attributionFields.utmTerm, params.get("utm_term"));

  if (location) {
    setField(attributionFields.ctaLocation, location);
  } else if (attributionFields.ctaLocation && !attributionFields.ctaLocation.value) {
    setField(attributionFields.ctaLocation, "Inline form");
  }
}

function setLeadInterest(value, location = "") {
  if (!leadForm || !leadInterest) return;

  leadInterest.value = value;
  if (leadBody) {
    leadBody.value = `${value} from esimagentapp.com`;
  }

  const selectedOption = leadForm.querySelector(`input[name="lead-choice"][value="${value}"]`);
  if (selectedOption) {
    selectedOption.checked = true;
  }

  setLeadAttribution(location);
}

function configureLeadForm() {
  if (!leadForm) return;

  setLeadAttribution();

  leadTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      setLeadInterest(trigger.dataset.leadTrigger, trigger.dataset.leadLocation);
      window.setTimeout(() => {
        leadForm.querySelector('input[type="email"]')?.focus();
      }, 120);
    });
  });

  leadForm.querySelectorAll('input[name="lead-choice"]').forEach((choice) => {
    choice.addEventListener("change", () => setLeadInterest(choice.value, "Form toggle"));
  });
}

function updateHeader() {
  if (!header) return;
  header.classList.toggle("is-elevated", window.scrollY > 12);
}

function closeMobileMenu() {
  if (!header || !mobileMenuToggle) return;
  header.classList.remove("is-menu-open");
  mobileMenuToggle.setAttribute("aria-expanded", "false");
  mobileMenuToggle.setAttribute("aria-label", "Open navigation menu");
}

function configureMobileMenu() {
  if (!header || !mobileMenuToggle) return;

  mobileMenuToggle.addEventListener("click", () => {
    const nextOpen = !header.classList.contains("is-menu-open");
    header.classList.toggle("is-menu-open", nextOpen);
    mobileMenuToggle.setAttribute("aria-expanded", String(nextOpen));
    mobileMenuToggle.setAttribute("aria-label", nextOpen ? "Close navigation menu" : "Open navigation menu");
  });

  header.querySelectorAll(".nav-links a").forEach((link) => {
    link.addEventListener("click", closeMobileMenu);
  });

  document.addEventListener("click", (event) => {
    if (!header.classList.contains("is-menu-open")) return;
    if (header.contains(event.target)) return;
    closeMobileMenu();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMobileMenu();
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 760) closeMobileMenu();
  });
}

function configureDataCalculator() {
  if (!dataCalculator) return;

  const daysInput = dataCalculator.querySelector("[data-calculator-days]");
  const daysMinus = dataCalculator.querySelector("[data-calculator-days-minus]");
  const daysPlus = dataCalculator.querySelector("[data-calculator-days-plus]");
  const daysOutput = dataCalculator.querySelector("[data-calculator-days-output]");
  const destinationInput = dataCalculator.querySelector("[data-calculator-destination]");
  const destinationList = dataCalculator.querySelector("[data-calculator-destinations]");
  const hotspotInput = dataCalculator.querySelector("[data-calculator-hotspot]");
  const gateForm = dataCalculator.querySelector("#calculator-lead-form");
  const emailInput = dataCalculator.querySelector("[data-calculator-email]");
  const submitButton = dataCalculator.querySelector("[data-calculator-submit]");
  const statusMessage = dataCalculator.querySelector("[data-calculator-status]");
  const destinationByNormalizedName = new Map(
    [
      calculatorUnknownDestination,
      ...calculatorSupportedDestinations
    ].map((destination) => [normalizeDestination(destination), destination])
  );
  let currentInput = null;
  let sentInputKey = "";

  function selectedValue(name, fallback) {
    return dataCalculator.querySelector(`input[name="${name}"]:checked`)?.value || fallback;
  }

  function clampedDays(value) {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed)) return 14;
    return Math.min(30, Math.max(1, parsed));
  }

  function setDays(nextDays) {
    if (!daysInput) return;
    daysInput.value = String(clampedDays(nextDays));
    updateCalculator();
  }

  function setCalculatorStatus(message, state = "") {
    if (!statusMessage) return;
    statusMessage.textContent = message;
    statusMessage.classList.toggle("lead-success", state === "success");
    statusMessage.classList.toggle("lead-error", state === "error");
  }

  function normalizeDestination(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();
  }

  function populateDestinationList() {
    if (!destinationList || destinationList.childElementCount) return;

    [
      calculatorUnknownDestination,
      ...calculatorSupportedDestinations
    ].forEach((destination) => {
      const option = document.createElement("option");
      option.value = destination;
      destinationList.append(option);
    });
  }

  function selectedDestination() {
    const enteredDestination = destinationInput?.value.trim() || "";
    if (!enteredDestination) return calculatorUnknownDestination;
    return destinationByNormalizedName.get(normalizeDestination(enteredDestination)) || "";
  }

  function validateDestination() {
    if (!destinationInput) return true;

    const enteredDestination = destinationInput.value.trim();
    const destination = selectedDestination();
    let message = "";

    if (enteredDestination && !destination) {
      message = "Choose a supported country or leave this blank if you are not sure yet.";
    }

    destinationInput.setCustomValidity(message);
    return !message;
  }

  function calculatorInputKey(input) {
    return JSON.stringify(input || {});
  }

  function updateCalculator() {
    const days = clampedDays(daysInput?.value);
    const wifi = selectedValue("calculator-wifi", "mostlyWifi");
    const usage = selectedValue("calculator-usage", "essentials");
    const hasHotspot = Boolean(hotspotInput?.checked);
    const destination = selectedDestination();
    if (daysOutput) {
      daysOutput.value = `${days} ${days === 1 ? "day" : "days"}`;
      daysOutput.textContent = daysOutput.value;
    }

    validateDestination();

    currentInput = {
      destination,
      tripDays: days,
      wifiProfile: wifi,
      usageProfile: usage,
      occasionalLaptopHotspot: hasHotspot
    };

    if (sentInputKey && sentInputKey !== calculatorInputKey(currentInput)) {
      sentInputKey = "";
      setCalculatorStatus("We will use this only for your calculator estimate, eSIM Agent updates, and travel-data tips.", "");
    }
  }

  function buildCalculatorPayload() {
    const params = new URLSearchParams(window.location.search);
    return {
      ...currentInput,
      email: emailInput?.value || "",
      pageUrl: window.location.href,
      landingUrl: landingUrl(),
      referrer: document.referrer || "Direct / unknown",
      utmSource: params.get("utm_source") || "",
      utmMedium: params.get("utm_medium") || "",
      utmCampaign: params.get("utm_campaign") || "",
      utmContent: params.get("utm_content") || "",
      utmTerm: params.get("utm_term") || ""
    };
  }

  async function sendCalculatorEstimate() {
    updateCalculator();

    if (!validateDestination()) {
      destinationInput?.reportValidity();
      return;
    }

    if (!gateForm || !emailInput || !emailInput.checkValidity()) {
      emailInput?.reportValidity();
      return;
    }

    if (destinationInput) destinationInput.value = selectedDestination();
    if (submitButton) submitButton.disabled = true;
    setCalculatorStatus("Sending your estimate...", "");

    try {
      const response = await fetch(calculatorEstimateEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildCalculatorPayload())
      });
      const json = await response.json().catch(() => ({}));

      if (!response.ok || json.success === false) {
        throw new Error(json.errorMsg || "We could not email the estimate. Please try again.");
      }

      sentInputKey = calculatorInputKey(currentInput);
      setCalculatorStatus("Check your inbox. We emailed your estimate and ways to make your data last.", "success");
      gateForm.reset();
    } catch (error) {
      setCalculatorStatus(error.message || "We could not email the estimate. Please try again.", "error");
    } finally {
      if (submitButton) submitButton.disabled = false;
      updateCalculator();
    }
  }

  daysMinus?.addEventListener("click", () => setDays(clampedDays(daysInput?.value) - 1));
  daysPlus?.addEventListener("click", () => setDays(clampedDays(daysInput?.value) + 1));
  destinationInput?.addEventListener("input", updateCalculator);

  dataCalculator
    .querySelectorAll('input[name="calculator-wifi"], input[name="calculator-usage"]')
    .forEach((input) => input.addEventListener("change", updateCalculator));
  hotspotInput?.addEventListener("change", updateCalculator);

  gateForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    sendCalculatorEstimate();
  });

  populateDestinationList();
  updateCalculator();
}

configureLeadForm();
configureMobileMenu();
configureDataCalculator();
updateHeader();

window.addEventListener("scroll", updateHeader, { passive: true });
